// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = require('./_an-object')
  , aFunction = require('./_a-function')
  , SPECIES   = require('./_wks')('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_species-constructor.js
 ** module id = ./node_modules/core-js/modules/_species-constructor.js
 ** module chunks = 1
 **/